import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Usuario, AuthAccount } from "../models";

@Injectable({
  providedIn: 'root',
})
export class PerfilStore {
  $Perfil: BehaviorSubject<Usuario | null> = new BehaviorSubject<Usuario | null>(null);
  perfil: Usuario | null = null;
  $PerfilAD: BehaviorSubject<AuthAccount | null> = new BehaviorSubject<AuthAccount | null>(null);

  constructor() {
    this.$Perfil = new BehaviorSubject<Usuario | null>(null);
    this.$PerfilAD = new BehaviorSubject<AuthAccount | null>(null);
  }

  /**
   * @description Obtiene los datos del perfil del usuario
   * @returns Observable
   */
  getPerfil() {
    return this.$Perfil.asObservable();
  }

  getPerfilAD() {
    return this.$PerfilAD.asObservable();
  }

  /**
   * @description  Establece el objeto del perfil  en el store y en el storage
   * @param {MenuItem[]} menu
   */
  setPerfil(perfil: Usuario) {
    perfil = this.buildPerfilRoles(perfil);
    this.perfil = perfil;
    this.$Perfil.next(perfil);
  }

  setPerfilAD(perfil: AuthAccount) {
    this.$PerfilAD.next(perfil);
  }

  buildPerfilRoles(perfil: Usuario): Usuario {
    if (perfil && perfil.rol) {
      perfil.esAdmin = perfil.rol.includes('ADMIN');
      perfil.esRRHH = perfil.rol.includes('RRHH');
      perfil.esColaborador = perfil.rol.includes('COLABORADOR');
      perfil.esMedico = perfil.rol.includes('MEDICO');
    }

    return perfil;
  }

  clearPerfil() {
    this.perfil = {} as Usuario;
    this.$Perfil.next( null as Usuario | null);
    this.$PerfilAD.next( null as AuthAccount | null);
  }
}